export const NAV_ELEMENTS: any = {
  START: { title: "Start", path: "/" },
  HTML_TEXT_NEW: { title: "Html text", path: "/html-text/new" },
  HTML_TEXT_LIST: { title: "Html text list", path: "/html-text/list" },
  UPUTSTVO: { title: "Uputstvo", path: "/uputstvo" },
};
